import React, { FunctionComponent, PropsWithChildren } from "react";

import { Layout, SpacingSize } from "../Layout";
import { ComponentSize } from "../types";

export type TextButtonSpacingProps = PropsWithChildren<{
    size?: ComponentSize;
}>;

/** Komponenta vnitřního odsazení textových tlačítek. */
export const TextButtonSpacing: FunctionComponent<TextButtonSpacingProps> = ({
    size = ComponentSize.large,
    children,
}) => {
    const smallSpacing = size === ComponentSize.small;

    return (
        <Layout
            spacingSizeVertical={smallSpacing ? SpacingSize.xxs : SpacingSize.xs}
            spacingSizeHorizontal={smallSpacing ? SpacingSize.xs : SpacingSize.s}
        >
            {children}
        </Layout>
    );
};
